import OrderStatusPage, { OrderStatusPageProps } from './OrderStatusPage';

export type { OrderStatusPageProps };
export default OrderStatusPage;
